import React, { useState } from "react";
import { createUser, UserPayload } from "../Services/userService"; // Import the service
import Swal from "sweetalert2";
import { indianStates } from "../Services/CommonService";
import { useSnackbar } from "notistack";
import { MSG_ALL_FIELDS_REQUIRED_TO_CREATE_SALES_PERSON, MSG_ALL_FIELDS_REQUIRED_TO_CREATE_USER, MSG_USER_CREATED, MSG_USER_NOT_CREATED } from "../Constants/MessageConstant";
import { LBL_CANCEL, LBL_CITY, LBL_CONTACT_PHONE, LBL_COUNTRY, LBL_CUSTOMER_NAME, LBL_EMAIL, LBL_GST, LBL_NEW, LBL_STATE, LBL_STREET, LBL_VENDOR_NAME, LBL_ZIP, PLACEHOLDER_CUSTOMER_NAME, PLACEHOLDER_EMAIL, PLACEHOLDER_FIRST_NAME, PLACEHOLDER_GST, PLACEHOLDER_LAST_NAME, PLACEHOLDER_PHONE_NUMBER, PLACEHOLDER_PIN_CODE, PLACEHOLDER_STREET_ADDRESS, PLACEHOLDER_VENDOR_NAME } from "../Constants/LabelConstants";
interface AddCustomerPopupProps {
  onSave: (data: UserPayload) => void; // Callback to send data to parent
  onClose: () => void; // Callback to close the popup
  type: "customer" | "salesPerson" | "vendor";
  orgId: string;
}

const labelMap: Record<string, string> = {
  customer: "Customer",
  salesPerson: "Salesperson",
  vendor: "Vendor",
};
const nameLabelMap: Record<string, string> = {
  customer: LBL_CUSTOMER_NAME,
  vendor: LBL_VENDOR_NAME,
};

const namePlaceholderMap: Record<string, string> = {
  customer: PLACEHOLDER_CUSTOMER_NAME,
  vendor: PLACEHOLDER_VENDOR_NAME,
};
const AddCustomerPopup: React.FC<AddCustomerPopupProps> = ({
  onSave,
  onClose,
  type,
  orgId,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  // Initial form data state
  const [formData, setFormData] = useState<UserPayload>({
    customerId: "",
    salutation: "Mr.",
    firstName: "",
    lastName: "",
    companyName: "",
    displayName: "",
    email: "",
    phone: "",
    address: {
      street: "",
      city: "",
      state: "",
      zipCode: "",
      country: "India",
    },
    website: "",
    orgId: "", // Replace with a dynamic value if necessary
    GSTIN: "",
    userType: type,
    customerName:"",
  });
  const [loading, setLoading] = useState(false);
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;

    if (name.includes("address.")) {
      const [_, key] = name.split(".");
      setFormData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          [key]: value,
        },
      }));
    } else if (name === "mobileNumber") {
      const validNumber = /^\d{13}$/;
      if (validNumber.test(value)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevData) => {
        const updatedData = {
          ...prevData,
          [name]: value,
        };
      
        if (type=="salesPerson" && (name === "salutation" || name === "firstName" || name === "lastName")) {
          updatedData.displayName = `${name === "salutation" ? value : updatedData.salutation} 
                                     ${name === "firstName" ? value : updatedData.firstName} 
                                     ${name === "lastName" ? value : updatedData.lastName}`?.trim();
        }
        if (type=="customer" && (name === "customerName")) {
          updatedData.displayName = `${name === "customerName" ? value : updatedData?.customerName}`?.trim();
        }
        if (type=="vendor" && (name === "customerName")) {
          updatedData.displayName = `${name === "customerName" ? value : updatedData?.customerName}`?.trim();
        }
        return updatedData;
      });
    }
  };

  const handleSave = async () => {
    const {firstName,phone,customerName,userType} = formData;
    //companyName need to handle
    if ((userType === "customer" || userType === "vendor") && 
    (!customerName || !phone || !formData.address.state)) {
      enqueueSnackbar(MSG_ALL_FIELDS_REQUIRED_TO_CREATE_USER, { variant: "error" });
      return;
    }
    if (userType =="salesPerson" && !firstName || !phone) {
      enqueueSnackbar(MSG_ALL_FIELDS_REQUIRED_TO_CREATE_SALES_PERSON, { variant: "error" });
      return;
    }

    setLoading(true);
    try {
      formData.orgId = orgId;
      const response = await createUser(formData);
      formData.customerId = response.Id; //Added the newly added customer id.
      // Swal.fire({
      //   icon: "success",
      //   title: "User Created",
      //   text: response.message,
      // });
      enqueueSnackbar(MSG_USER_CREATED, { variant: "success" });
      onSave(formData); // Pass the customer to the parent
      setLoading(false);
      onClose(); // Close the popup
    } catch (error) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Failed to create user",
      //   text: "Please try again.",
      // });
      enqueueSnackbar(MSG_USER_NOT_CREATED, { variant: "error" });
      setLoading(false);
    }
  };

  //Handle state onChanges
  const handleStateChange = (e: { target: { value: any; }; }) => {
    setFormData((prevData) => ({
      ...prevData,
      address: { ...prevData.address, state: e.target.value },
    }));
  };
  

  return (
    <div className="popup">
      <div className="popup-content">
        {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: "relative",
          float: "right",
          background: "red",
          border: "none",
          fontSize: "24px",
          cursor: "pointer",
          color: "#333",
          left: "10px",
          bottom: "15px",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        &times;
      </button>
      <h3>{LBL_NEW} {labelMap[type] || ""}</h3>
        {/* Form Fields */}
        
        <div className="form-group">
          {/* <label>
            Primary Contact<span style={{ color: "red" }}>*</span>
          </label> */}
          {type === "customer" || type === "vendor"   ? (
          <>
            <div className="form-group">
              <label>
            
              {nameLabelMap[type] || "Name"} <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                placeholder={namePlaceholderMap[type] || "Enter name"}
                required
              />
            </div>
          </>
        ):(
          <div className="inline-fields">
            <select
              name="salutation"
              value={formData.salutation}
              onChange={handleChange}
            >
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Ms.">Ms.</option>
            </select>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder={PLACEHOLDER_FIRST_NAME}
              required
            />
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder={PLACEHOLDER_LAST_NAME}
              //required
            />
          </div>)}
        </div>
        {type === "customer" && (
          <>
            {/* <div className="form-group">
              <label>
                Company Name
              </label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Company Name"
                //required
              />
            </div> */}
            <div className="form-group">
              <label>
                {LBL_GST}
                {/* <span style={{ color: "red" }}>*</span> */}
              </label>
              <input
                type="text"
                name="GSTIN"
                value={formData.GSTIN}
                onChange={handleChange}
                placeholder={PLACEHOLDER_GST}
                //required
              />
            </div>
          </>
        )}
        <div className="form-group">
          <label>
            {LBL_EMAIL}
            {/* <span style={{ color: "red" }}>*</span> */}
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={PLACEHOLDER_EMAIL}
           // required
          />
        </div>
        <div className="form-group">
          <label>
            {LBL_CONTACT_PHONE}<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={(e) => {
              const validNumber = /^[0-9]{0,10}$/;
              const invalidNumber = /^-|\d{14,}$/;
              if (invalidNumber.test(e.target.value)) {
                Swal.fire({
                  icon: "error",
                  title: "Invalid Phone Number",
                  text: "Please enter a valid phone number,10 digits only and no negative values.",
                  customClass: {
                    container: "swal-validation-errors",
                  },
                  backdrop: `
                    rgba(0,0,0,0.4)
                    center
                    no-repeat
                  `,
                  position: "center",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  toast: true,
                });
                const swalValidationErrors = document.querySelector('.swal-validation-errors') as HTMLElement;
                if (swalValidationErrors) {
                  swalValidationErrors.style.zIndex = '10000';
                }
              } else if (validNumber.test(e.target.value)) {
                handleChange(e);
              }
            }}
            placeholder={PLACEHOLDER_PHONE_NUMBER}
            required
          />
        </div>
        <div className="form-group">
          <label>
            {LBL_STREET}
            {/* <span style={{ color: "red" }}>*</span> */}
          </label>
          <input
            type="text"
            name="address.street"
            value={formData.address.street}
            onChange={handleChange}
            placeholder={PLACEHOLDER_STREET_ADDRESS}
            //required
          />
        </div>
        <div className="form-group">
          <label>
            {LBL_CITY}
            {/* <span style={{ color: "red" }}>*</span> */}
          </label>
          <input
            type="text"
            name="address.city"
            value={formData.address.city}
            onChange={handleChange}
            placeholder={LBL_CITY}
            // required
          />
        </div>
        <div className="form-group">
          <label>
            {LBL_STATE}<span style={{ color: "red" }}>*</span>
          </label>
          <select
      name="address.state"
      value={formData.address.state}
      onChange={handleStateChange}
      required
      >
      <option value="">Select State</option>
      {indianStates.map((state) => (
        <option key={state.value} value={state.label} >
          {state.label}
        </option>
      ))}
    </select>
        </div>
        <div className="form-group">
          <label>
          {LBL_ZIP}
            {/* Zip<span style={{ color: "red" }}>*</span> */}
          </label>
          <input
            type="text"
            name="address.zipCode"
            value={formData.address.zipCode}
            onChange={handleChange}
            placeholder={PLACEHOLDER_PIN_CODE}
            //required
          />
        </div>
        <div className="form-group">
          <label>
            {LBL_COUNTRY}
            <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="address.country"
            value={formData.address.country}
            onChange={handleChange}
            placeholder="Country"
            disabled
          />
        </div>
        <div className="popup-buttons">
          <button
            className="popup-button"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button className="popup-button cancel" onClick={onClose}>
            {LBL_CANCEL}
          </button>
        </div>
      </div>
    </div>
  );
};
export default AddCustomerPopup;
